import styled from '@emotion/styled'
import { type Theme, Typography } from '@mui/material'

export const Label = styled(Typography)`
	${({ theme }: { theme: Theme }) => `
        color: ${theme.palette.text.secondary};
    `}
	line-height: 1rem;
	padding-top: 0px;
	padding-bottom: 0px;
`
